export const closeButtonDropdown = () => {
    const htmlNode = document.querySelector('html');
    const drawerNode: HTMLDivElement | null = document.querySelector('.sparky-c-drawer.sparky-is-active');

    const clickEvent = new Event('mousedown', {
        bubbles: true,
        cancelable: false,
    });

    if (htmlNode) {
        htmlNode.dispatchEvent(clickEvent);
    }

    if (drawerNode) {
        drawerNode.dispatchEvent(clickEvent);
    }

    const closeButton = drawerNode?.querySelector('.sparky-c-drawer__header .sparky-c-drawer__close-button');

    if (closeButton) {
        closeButton.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: false,
            })
        );
    }
};
